import http from '../utils/http';
import axios from 'axios';

const baseRoute = '/operacao/laudo';

export default {
    buscarPorId(idLaudo) {
        return http.get({
            url: baseRoute + `/${idLaudo}`,
            lockScreen: true,
            lockMessage: 'Buscando informações de fiscalização da operação'
        });
    },

    buscar(payload) {
        return http.post({
            url: baseRoute,
            data: payload,
            lockScreen: true,
            lockMessage: 'Buscando fiscalizações de operações'
        });
    },

    inserir(body) {
        return http.post({
            url: baseRoute + '/inserir',
            data: body,
            lockScreen: true,
            lockMessage: 'Solicitando fiscalização'
        });
    },

    gerarShapeFile(id) {
        const fileLink = document.createElement('a');
        return http
            .get({
                url: baseRoute + `/${id}/gerar-shape`,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: 'Preparando shape para download'
            })
            .then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            })
            .catch(error => {
                return Promise.reject(error);
            })
            .finally(() => {
                fileLink.remove();
            });
    },

    async gerarExcel() {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/gerar-excel`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    inserirResultado(input) {
        const formData = new FormData();

        const url =
            process.env.VUE_APP_HTTP_PATH + '/operacao/laudo/inserir-resultado';

        formData.append('id', input.id);
        formData.append('status', input.status);
        formData.append('file', input.arquivo);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    downloadResultado(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/download-resultado`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando resultado do laudo para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    }
};
